import { AddressDisplay } from '~/components/component-library/AddressDisplay'
import { ListItemProps } from '~/components/component-library/List/types'
import { DecodedCallSummary } from '~/components/txn-display/state-change/types'
import { SupportedChainId } from '~/constants/chains'
import { IAddress, TransactionDisplayCall } from '~/types'
import { shortenAddress } from '~/utils/addresses'

const getSelector = (data: string | undefined): string | undefined => {
  if (!data || data.length < 10) return undefined
  return data.slice(0, 10)
}

export const buildDisplayCallListItems = ({
  calls,
  chainId,
  smartAccountAddress,
  decodedCalls,
}: {
  calls: Array<
    Pick<
      TransactionDisplayCall,
      'to' | 'functionSignature' | 'contractName'
    > & {
      calldata?: string
      data?: string
    }
  >
  chainId?: SupportedChainId
  smartAccountAddress?: IAddress
  decodedCalls?: DecodedCallSummary[]
}): ListItemProps[] => {
  if (!chainId || !smartAccountAddress) return []

  return calls.flatMap((call, index) => {
    const data = call.calldata ?? call.data
    if (!data || data === '0x') return []

    const decodedCall = decodedCalls?.[index]
    const functionName =
      call.functionSignature?.split('(')[0] ?? decodedCall?.functionName
    const selector = getSelector(data)
    const title = functionName ? `${functionName}()` : (selector ?? 'unknown()')
    const subtitle = call.contractName ?? shortenAddress(call.to)

    return {
      key: `call-${index}`,
      content: (
        <AddressDisplay
          address={smartAccountAddress}
          chainId={chainId}
          layout="two-line"
        />
      ),
      meta: (
        <div className="flex flex-col items-end justify-center gap-0.5">
          <span className="h-6 text-base leading-6 text-primary">{title}</span>
          <span className="h-4 text-sm leading-4 text-secondary">
            {subtitle}
          </span>
        </div>
      ),
    }
  })
}
